/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketScanResponse } from './TicketScanResponse';
import {
    TicketScanResponseFromJSON,
    TicketScanResponseFromJSONTyped,
    TicketScanResponseToJSON,
} from './TicketScanResponse';
import type { ScanStatus } from './ScanStatus';
import {
    ScanStatusFromJSON,
    ScanStatusFromJSONTyped,
    ScanStatusToJSON,
} from './ScanStatus';
import type { TicketType } from './TicketType';
import {
    TicketTypeFromJSON,
    TicketTypeFromJSONTyped,
    TicketTypeToJSON,
} from './TicketType';

/**
 * 
 * @export
 * @interface DecryptedTicketScan
 */
export interface DecryptedTicketScan {
    /**
     * 
     * @type {Date}
     * @memberof DecryptedTicketScan
     */
    createdAt: Date;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: any; }}
     * @memberof DecryptedTicketScan
     */
    externalScanResponse: { [key: string]: any; };
    /**
     * 
     * @type {TicketScanResponse}
     * @memberof DecryptedTicketScan
     */
    scanResponse: TicketScanResponse;
    /**
     * 
     * @type {TicketType}
     * @memberof DecryptedTicketScan
     */
    ticketType: TicketType;
    /**
     * 
     * @type {ScanStatus}
     * @memberof DecryptedTicketScan
     */
    status: ScanStatus;
    /**
     * 
     * @type {string}
     * @memberof DecryptedTicketScan
     */
    truncatedBarcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecryptedTicketScan
     */
    barcodeHash: string;
    /**
     * 
     * @type {string}
     * @memberof DecryptedTicketScan
     */
    decryptedBarcode: string;
    /**
     * 
     * @type {string}
     * @memberof DecryptedTicketScan
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof DecryptedTicketScan
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecryptedTicketScan
     */
    playerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecryptedTicketScan
     */
    id: string;
}



/**
 * Check if a given object implements the DecryptedTicketScan interface.
 */
export function instanceOfDecryptedTicketScan(value: object): value is DecryptedTicketScan {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('externalScanResponse' in value) || value['externalScanResponse'] === undefined) return false;
    if (!('scanResponse' in value) || value['scanResponse'] === undefined) return false;
    if (!('ticketType' in value) || value['ticketType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('barcodeHash' in value) || value['barcodeHash'] === undefined) return false;
    if (!('decryptedBarcode' in value) || value['decryptedBarcode'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DecryptedTicketScanFromJSON(json: any): DecryptedTicketScan {
    return DecryptedTicketScanFromJSONTyped(json, false);
}

export function DecryptedTicketScanFromJSONTyped(json: any, ignoreDiscriminator: boolean): DecryptedTicketScan {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'externalScanResponse': json['externalScanResponse'],
        'scanResponse': TicketScanResponseFromJSON(json['scanResponse']),
        'ticketType': TicketTypeFromJSON(json['ticketType']),
        'status': ScanStatusFromJSON(json['status']),
        'truncatedBarcode': json['truncatedBarcode'] == null ? undefined : json['truncatedBarcode'],
        'barcodeHash': json['barcodeHash'],
        'decryptedBarcode': json['decryptedBarcode'],
        'customerId': json['customerId'],
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'id': json['id'],
    };
}

export function DecryptedTicketScanToJSON(value?: DecryptedTicketScan | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'externalScanResponse': value['externalScanResponse'],
        'scanResponse': TicketScanResponseToJSON(value['scanResponse']),
        'ticketType': TicketTypeToJSON(value['ticketType']),
        'status': ScanStatusToJSON(value['status']),
        'truncatedBarcode': value['truncatedBarcode'],
        'barcodeHash': value['barcodeHash'],
        'decryptedBarcode': value['decryptedBarcode'],
        'customerId': value['customerId'],
        'deviceId': value['deviceId'],
        'playerId': value['playerId'],
        'id': value['id'],
    };
}

